
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_g8no8_1w0bf_5",
  "action-button": "awsui_action-button_g8no8_1w0bf_9",
  "control": "awsui_control_g8no8_1w0bf_13",
  "inline-label": "awsui_inline-label_g8no8_1w0bf_17"
};
  